<template>
  <div>
    <div class="info_details" v-if="checkProperty(petitionDetails, 'beneficiaryDetails', 'name')">
      <vs-col class="m-auto float-none" vs-type="block" vs-justify="center" vs-align="center" vs-lg="11"
      vs-sm="12">
        <h5>Your information as per your employer records</h5>
        <ul>
          <li v-if="checkProperty(petitionDetails, 'beneficiaryDetails', 'firstName')">
            <div class="list-info">
              <label>First Name</label>
              <p>{{checkProperty(petitionDetails, 'beneficiaryDetails', 'firstName')}}</p>
            </div>
          </li>
          <li v-if="checkProperty(petitionDetails, 'beneficiaryDetails', 'middleName')">
            <div class="list-info">
              <label>Middle Name</label>
              <p>{{checkProperty(petitionDetails, 'beneficiaryDetails', 'middleName')}}</p>
            </div>
          </li>
          <li v-if="checkProperty(petitionDetails, 'beneficiaryDetails', 'lastName')">
            <div class="list-info">
              <label>Last Name</label>
              <p>{{checkProperty(petitionDetails, 'beneficiaryDetails', 'lastName')}}</p>
            </div>
          </li>
          <li v-if="checkProperty(petitionDetails, 'beneficiaryDetails', 'email')">
            <div class="list-info">
              <label>Email Address</label>
              <p>{{checkProperty(petitionDetails, 'beneficiaryDetails', 'email')}}</p>
            </div>
          </li>
          <li v-if="checkProperty(petitionDetails, 'beneficiaryDetails', 'phone')">
            <div class="list-info">
              <label>Phone Number</label>
              <p>
                <template v-if="checkProperty(petitionDetails['beneficiaryDetails'] ,'phoneCountryCode' ,'countryCallingCode')">{{checkProperty(petitionDetails['beneficiaryDetails'] ,'phoneCountryCode' ,'countryCallingCode')+"&nbsp;"}}</template>
                {{petitionDetails.beneficiaryDetails.phone | formatPhone}}
              </p>
            </div>
          </li>
          <li class="w-full" v-if=" checkProperty(petitionDetails['beneficiaryDetails'] ,'address' )&&(
            checkProperty(petitionDetails['beneficiaryDetails'] ,'address' ,'line1' )
            || checkProperty(petitionDetails['beneficiaryDetails']['address'] ,'locationDetails' ,'name' )
            || checkProperty(petitionDetails['beneficiaryDetails']['address'] ,'stateDetails' ,'name' )
            || checkProperty(petitionDetails['beneficiaryDetails']['address'] ,'countryDetails' ,'name' ))">
            <div class="list-info">
              <label>Address</label>
              <p v-html="$options.filters.addressformat(petitionDetails.beneficiaryDetails.address)"></p>
              <!-- addressformat -->
            </div>
          </li>
        </ul>
        </vs-col>
    </div>
    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="11"
      vs-sm="12">
      <div class="form-container pt-10">
        <h3 class="small-header">Employee Information</h3>
        <p class="marb10">Employee Information and Attestation: Employee must complete and sign Section 1 of Form I-9 no letter than the <strong>first day of employment</strong>, but not before accepting a job offer.</p>
        <div class="vx-row"> 
          <vs-col class="w-full marb30">
            <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">
              Please check your details as per your employer records and fill the information accordingly in the fileds below. It have any information available then please mention N/A to Unknown
            </vs-alert> 
          </vs-col>
          <div class="vx-col w-full">
            <vx-input-group class="form-input-group FML">
              <immiInput :display="true" :formscope="formscope" v-model="value.firstName" :fieldName="'firstName'" :cid="'firstName'" :required="true" label="First Name" placeHolder="First Name" />
              <immiInput :display="true" :formscope="formscope" v-model="value.middleName" :fieldName="'middleName'" :cid="'middleName'" :required="false" label="Middle Name" placeHolder="Middle Name" />
              <immiInput :display="true" :formscope="formscope" v-model="value.lastName" :fieldName="'lastName'" :cid="'lastName'" :required="true" label="Last Name" placeHolder="Last Name" />
            </vx-input-group>
          </div>
          <immiInput  wrapclass="md:w-1/2" :formscope="formscope" v-model="value.otherLastName" :fieldName="'otherLastName'" :cid="'otherLastName'" :required="false" :display="true"  label="Other Last Names Used" placeHolder="Other Last Names Used"/>
          <datepickerField  :display="true" :vvas="'Date of Birth'"  :formscope="formscope" :fieldName="'dateOfBirth'" :dateEnableTo="startEligibleDate" :cid="'dateOfBirth'" :validationRequired="true" v-model="value.dateOfBirth" label="Date of Birth" />
          <div class="vx-col w-fill md:w-1/2 ssn_field">
            <immiMask :display="true"  :patren="['### - ## - ####']" datatype="min:9|max:9" :disabled="value.hasSSN" :wrapclass="''" cid="benfSSN" :formscope="formscope" v-model="value.SSN" :fieldName="'SSN'"  :required="value.hasSSN?false:true"  label="Social Security Number" vvas="Social Security Number" placeHolder="123 - 45 - 6789" />
            <!-- <immiInput  wrapclass="" :formscope="formscope" :fieldName="'SSN'" :cid="'SSN'" :disabled="value.hasSSN" :required="value.hasSSN?false:true" v-model="value.SSN" :display="true"  label="SSN" placeHolder="SSN"/> -->
            <vs-checkbox id="premium" name="premiumProcessing" @change="updateSSN" v-model="value.hasSSN">Not Available
            </vs-checkbox>
          </div>
          
          
          <immiPhone :display="true" :formscope="formscope" @updatephoneCountryCode="updatecellPhoneCountryCode" :countrycode="value.phoneCountryCode.countryCode" :cid="'phone'"  v-model="value.phone" :fieldName="'phone'" :required="true" label="Telephone Number" placeHolder="Telephone Number" />
          <immiInput  wrapclass="md:w-1/2" :formscope="formscope" :fieldName="'email'" :cid="'email'" :required="true" v-model="value.email" :display="true" 
           label="Email" placeHolder="Email" :disabled="value.email?true:false"/>
        </div>
        <div>
          <template v-if="checkProperty(countries, 'length')>0">
            <h3 class="small-header">Current Address</h3>
            <addressField :display="true" :formscope="formscope" :showaptType="true" :validationRequired="true"
            :countries="countries" v-model="value.address" :fieldName="'address'" :disableCountryWithUS="true"/>
          </template>
      </div>
      </div>
    </vs-col>       
  </div>
     
</template>

<script>
import immiMask from "@/views/forms/fields/maskinput.vue";
    import immiPhone from "@/views/forms/fields/phonenumber.vue";
    // import genderField from '@/views/fields/gender.vue'
    import immiInput from "@/views/forms/fields/simpleinput.vue";
    import addressField from "@/views/forms/fields/address.vue";
    import datepickerField from "@/views/forms/fields/datepicker.vue";
    import selectField from "@/views/forms/fields/simpleselect.vue";
    export default {
      inject: ["parentValidator"],
      created() {
        this.$validator = this.parentValidator;
      },
      data() {
        return {
          startEligibleDate: new Date().setFullYear(new Date().getFullYear() - 18),
        }
      },
      methods: {
        updateSSN(){
          let self = this;
          setTimeout(()=>{
            if(self.value.hasSSN){
              self.value.SSN = '';
            }
          })
        },
        updatecellPhoneCountryCode(data){
          this.value.phoneCountryCode =data;
        },
        setCurrentTab(tab) {
          this.currentTab = tab;
        }
      },
      components: {
        immiMask,
        immiPhone,
       // genderField,
        immiInput,
        addressField,
        datepickerField
      },
      props:{
        value:null,
        petition:null,
        formscope:{
          type:String,
          default:''
        }, 
        countries:{
          type:Array,
          default:[]
        },
        petitionDetails:null,
      },
      mounted() {
        
      }
    }
</script>
